const LanguageTag = ({ text, styleClass }) => {
  return <div className={`${styleClass}`}>{text}</div>;
};

export default LanguageTag;
